/**
 * Build time configurations of the api base urls.
 */
let gatewayConfig: {
  gatewayUrl: string;
  loginConnectorUrl: string;
};

switch (process.env.APP_ENV ?? process.env.NODE_ENV) {
  case "production":
    gatewayConfig = {
      gatewayUrl: "https://gateway.gyldendal.dk",
      loginConnectorUrl: "https://loginconnector.gyldendal.dk",
    };
    break;

  case "staging":
    gatewayConfig = {
      gatewayUrl: "https://qa-gateway.gyldendal.dk",
      loginConnectorUrl: "https://qa-loginconnector.gyldendal.dk",
    };
    break;

  default:
    gatewayConfig = {
      gatewayUrl: "https://test-gateway.gyldendal.dk",
      loginConnectorUrl: "https://test-loginconnector.gyldendal.dk",
    };
}

export { gatewayConfig };
